export const VpSalesAndMarketingTemplated = {
    getFormName() {
        return {

            q1:"",
            q2:"",
            q3:"",
            q4:"",

            vpCommentsq1: "",
            vpCommentsq2: "",
            vpCommentsq3: "",
            vpCommentsq4: "",
            vpCommentsq5: "",

            coreValuesq1:'',
            coreValuesq2:'',
            coreValuesq3:'',
            coreValuesq4:'',
            
            id:'0',
            from_date:'',
            year_goal:'',
            check_in_how_are_you_doing:'',
            what_can_i_do_to_support_you:'',

            annual_deliveables:[{
                title:'',
                description:''
            }],
            performance: this.getDataForAll(),
            discussionItem: [
                { 
                discussion_items:''}
             ],

             toDiscuss: [
                { title:'',
                 description:''}
             ],

            primary_task:[{
                title:'',
                due_date:'',
                actual_date_completed:'',
                comments:'',
            }],
            secondary_task:[{
                title:'',
                due_date:'',
                actual_date_completed:'',
                comments:'',
            }], 
            any_addtional_topic:[{
                title:'',
                comments:'',
            }],
            goals_for_the_week:[{
                title:'',
                status_1:'',
                status_2:'',
                reason_1:'',
                reason_2:'',
            }],
            leads:[{
                title:'', 
                jan:'', 
                feb:'',
                mar:'',
                apr:'',
                may:'',
                june:'',
                july:'',
                aug:'',
                sep:'',
                oct:'',
                nov:'',
                decem:'',
                year:'',
                total:'',
            }],
            web_stats:this.webState(),
            marketing_campaigns:this.marketingCampaigns(),
            google_adwords:this.googleAdwords(),
            bings_adwords:this.bingsAdwords(),
            houzz:this.houzz(),
            facebook_instgram_ads:this.facebookInstgramAds(),
            linkedins:this.linkedins(),

            social_media_stats:this.socialMediaStats(),


        }
    },
    getDataForAll(){
    
        return [
            {
                performanceBonusMeasReview: "Weekly workload rating 1-10",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of Sales Meetings Attended (includes both site visits and CE meetings)",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of Active Leads",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of FSA's signed",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Number of Contracts signed",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Sales meetings >50k held in board room (< 50k estimate sent via email) - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "LIDA Home sales book left with all leads - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Concept Estimate sent to clients <$50k under 1 week – 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Check in with Concept Estimate Clients once per week, <6pm every Monday or Thursday (depending on client) for 3 weeks then archive out of active - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Send out digital copy of CE in BT within 24 hours of Conceptual Presentation and/or next business day. - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "All sales leads fully updated in the Lead tracker & Builder Trend <6pm Monday and complete (includes all correct formatting, documents & emails correspondence put into BT) - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Meet with Dave/Terry within 5 days of FSA being signed - 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "Contact at least one new person each week – 5 points",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            {
                performanceBonusMeasReview: "List of lost clients to Sales & Marketing VP <Monday – 5 points TBD",
                clientPlayBook: "",
                vpPoints_1: "",
                clientEmailWeek: "",
                vpPoints_2: "",
                pmComments: "",
                vpCOComments: ""
            },
            
        ];
    },
    webState() {
        return [{
            title: 'Sessions/Website Traffic',
            jan: '3500',
            feb: '3800',
            mar: '3200',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'New Sessions',
            jan: '79.35%',
            feb: '79.94%',
            mar: '78.11%',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Pages per session',
            jan: '1.76',
            feb: '1.79',
            mar: '2.02',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Bounce Rate/Engagement rate as of Aug 2023*',
            jan: '53.61%',
            feb: '52.39%',
            mar: '61.04%',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Avg Session Duration',
            jan: '2.28',
            feb: '2.12',
            mar: '2.56',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Conversions',
            jan: '22',
            feb: '23',
            mar: '47',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Conversions Rate: Converstions/Sessions',
            jan: '0.63%',
            feb: '0.61%',
            mar: '1.47%',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        }]

    },

    marketingCampaigns() {
        return  [
                {
                    title: 'Clicks',
                    jan: '708',
                    feb: '1000',
                    mar: '1200',
                    apr: '1600',
                    may: '1900',
                    june: '4700',
                    july: '1500',
                    aug: '1300',
                    sep: '1600',
                    oct: '1200',
                    nov: '1100',
                    decem: '1200',
                    year: '2022',
                },
                {
                    title: 'CTR',
                    jan: '0.40%',
                    feb: '0.80%',
                    mar: '0.70%',
                    apr: '1.10%',
                    may: '0.20%',
                    june: '1.20%',
                    july: '1.00%',
                    aug: '1.10%',
                    sep: '1.10%',
                    oct: '1.00%',
                    nov: '1.10%',
                    decem: '1.80%',
                    year: '2022',
                },
                {
                    title: 'Cost',
                    jan: '$859.74',
                    feb: '$745.35',
                    mar: '$877.70',
                    apr: '$878.00',
                    may: '$654.58',
                    june: '$777.01',
                    july: '$684.30',
                    aug: '$764.95',
                    sep: '$650.17',
                    oct: '$668.83',
                    nov: '$771.05',
                    decem: '$694.84',
                    year: '2022',
                },
                {
                    title: 'Conversions',
                    jan: '6',
                    feb: '8',
                    mar: '8',
                    apr: '8',
                    may: '4',
                    june: '7',
                    july: '4',
                    aug: '5',
                    sep: '7',
                    oct: '4',
                    nov: '7',
                    decem: '2',
                    year: '2022',
                },
                {
                    title: 'Cost/Click',
                    jan: '$1.21',
                    feb: '$0.72',
                    mar: '$0.74',
                    apr: '$0.57',
                    may: '$0.34',
                    june: '$0.16',
                    july: '$0.45',
                    aug: '$061',
                    sep: '$0.41',
                    oct: '$0.58',
                    nov: '$0.70',
                    decem: '$0.56',
                    year: '2022',
                },
                {
                    title: 'Cost/Conv',
                    jan: '$143.26',
                    feb: '$93.17',
                    mar: '$109.71',
                    apr: '$109.75',
                    may: '$163.64',
                    june: '$111.00',
                    july: '$171.08',
                    aug: '$152.99',
                    sep: '$92.88',
                    oct: '$167.21',
                    nov: '$110.15',
                    decem: '$347.42',
                    year: '2022',
                },
            ]
    },

    googleAdwords(){
        return [
            {
                title: 'Clicks',
                jan: '3800',
                feb: '3100',
                mar: '1800',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: ' ',
                year: '2024',
            },
            {
                title: 'CTR',
                jan: '2.60%',
                feb: '1.70%',
                mar: '3.50%',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: '',
                year: '2024',
            },
            {
                title: 'Cost',
                jan: '$3220',
                feb: '$3350',
                mar: '$3190',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: ' ',
                year: '2024',
            },
            {
                title: 'Conversions',
                jan: '19',
                feb: '16',
                mar: '41',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: ' ',
                year: '2024',
            },
            {
                title: 'Cost/Click',
                jan: '$0.86',
                feb: '$1.07',
                mar: '$1.77',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: ' ',
                year: '2024',
            },
            {
                title: 'Cost/Conv',
                jan: '$169.29',
                feb: '$209.50',
                mar: '$77.92',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: ' ',
                year: '2024',
            },
        ]
    },

    bingsAdwords(){
        
        return [{
            title: 'Click',
            jan: '3',
            feb: '194',
            mar: '214',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'CTR',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Cost',
            jan: '$9.90',
            feb: '$304.12',
            mar: '$304.24',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Conversions',
            jan: '0',
            feb: '7',
            mar: '1',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Cost/Click',
            jan: '$3.30',
            feb: '$1.57',
            mar: '$1.42',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        {
            title: 'Cost/Conv',
            jan: '$0.00',
            feb: '$43.45',
            mar: '$304.24',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '2024',
        },
        ]
    },
    houzz() {
        return [{
            title: 'Leads',
            jan: '',
            feb: '2',
            mar: '2',
            apr: '1',
            may: '5',
            june: '5',
            july: '3',
            aug: '3',
            sep: '3',
            oct: '5',
            nov: '0',
            decem: '2',
            year: '2023',
        },
        {
            title: 'Cost (one month was credited)',
            jan: '',
            feb: '$1077.00',
            mar: '$1077.00',
            apr: '$1077.00',
            may: '$1077.00',
            june: '$1077.00',
            july: '$1077.00',
            aug: '$1077.00',
            sep: '$1077.00',
            oct: '$1077.00',
            nov: '$1077.00',
            decem: '$1077.00',
            year: '2023',
        },
        {
            title: 'Cost/lead',
            jan: '',
            feb: '$538.50',
            mar: '$538.50',
            apr: '$1077.00',
            may: '$215.40',
            june: '$215.40',
            july: '$359.00',
            aug: '$359.00',
            sep: '$359.00',
            oct: '$215.40',
            nov: '$1077.00',
            decem: '$538.50',
            year: '202',
        },
        ]
    },

    facebookInstgramAds(){
        return [{
            title: 'Clicks',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        {
            title: 'Cost',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        {
            title: 'Cost per Click',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        {
            title: 'Notes',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        ]
    },
    linkedins() {
       
        return [{
            title: 'Clicks',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        {
            title: 'Cost',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        {
            title: 'Cost per Click',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        {
            title: 'Notes',
            jan: '',
            feb: '',
            mar: '',
            apr: '',
            may: '',
            june: '',
            july: '',
            aug: '',
            sep: '',
            oct: '',
            nov: '',
            decem: '',
            year: '',
        },
        ] 
    },

    socialMediaStats() {
        return [
            {
                title: 'INSTAGRAM',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: '',
                year: '',
            },
            {
                title: 'Followers',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'Likes (last 10)',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'Comments (last 10)',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'FACEBOOK',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: '',
                year: '',
            },
            {
                title: 'Followers',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'Likes (last 10)',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'Comments (last 10)',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'LINKEDIN',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '',
                decem: '',
                year: '',
            },
            {
                title: 'Followers',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'Likes (last 10)',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
            {
                title: 'Comments (last 10)',
                jan: '',
                feb: '',
                mar: '',
                apr: '',
                may: '',
                june: '',
                july: '',
                aug: '',
                sep: '',
                oct: '',
                nov: '3263',
                decem: '',
                year: '',
            },
        ]
    }



}